import { TranslateService } from "@ngx-translate/core";
import { catchError, firstValueFrom, of } from "rxjs";
import { DEFAULT_LANGUAGE } from "./constants";
import { ShopifyAppBridgeService } from "./services/shopify-app-bridge/shopify-app-bridge.service";

/**
 * Holds the first render until the merchant's language file is loaded. Many screens read their texts once with
 * `translateService.instant()` (breadcrumbs, tabs, labels); before the file arrives that returns the raw key, and the
 * key stays on screen until the next navigation. A failed load never blocks the app: the pipes still catch up later.
 * The English fallback loads in the background: every language file has every key (i18n.spec), so it never shows
 * on first render and waiting for it would only add a second download before the app paints.
 */
export const loadInitialTranslations =
  (translateService: TranslateService, shopifyAppBridgeService: ShopifyAppBridgeService): (() => Promise<void>) =>
  async () => {
    const language = shopifyAppBridgeService.isEmbedded ? shopifyAppBridgeService.resolveLanguage() : DEFAULT_LANGUAGE;
    translateService.setFallbackLang(DEFAULT_LANGUAGE).pipe(catchError(() => of(null))).subscribe();
    await firstValueFrom(translateService.use(language).pipe(catchError(() => of(null))));
  };
